/* Quiet Theory Records — Theme JS */

// Mobile nav toggle
document.addEventListener('DOMContentLoaded', function () {

  // Mobile nav
  const navToggle = document.querySelector('.nav-toggle');
  const siteNav   = document.querySelector('.site-nav');

  if (navToggle && siteNav) {
    navToggle.addEventListener('click', function () {
      const open = siteNav.classList.toggle('nav--open');
      navToggle.textContent = open ? '[ close ]' : '[ menu ]';
    });
  }

  // Product image thumbnails
  const thumbs   = document.querySelectorAll('.product-thumb');
  const mainImg  = document.querySelector('.product-main-img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.src.replace('_80x80', '_600x600');
    });
  });

  // Crowdfund progress bar animation
  const fills = document.querySelectorAll('.progress-fill[data-pct]');
  fills.forEach(function (fill) {
    const pct = parseFloat(fill.dataset.pct) || 0;
    // Start at 0, animate to target
    fill.style.width = '0%';
    setTimeout(function () {
      fill.style.width = Math.min(pct, 100) + '%';
    }, 200);
  });

  // Cart quantity buttons
  document.querySelectorAll('.qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = btn.closest('.qty-wrap')?.querySelector('.qty-input');
      if (!input) return;
      const val = parseInt(input.value) || 1;
      if (btn.dataset.dir === 'up')   input.value = val + 1;
      if (btn.dataset.dir === 'down') input.value = Math.max(1, val - 1);
    });
  });

  // Newsletter form (front-end only — Shopify handles submission)
  const newsletterForm = document.querySelector('.newsletter-form[data-type="newsletter"]');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function (e) {
      const btn = newsletterForm.querySelector('.newsletter-submit');
      if (btn) btn.textContent = 'sending...';
    });
  }

  // Sticky header class on scroll
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('header--scrolled', window.scrollY > 10);
    }, { passive: true });
  }
});

// Cart AJAX helper (used by add-to-cart forms)
window.QTR = window.QTR || {};

QTR.addToCart = async function (formEl) {
  const formData = new FormData(formEl);
  const btn = formEl.querySelector('[type="submit"]');
  const orig = btn ? btn.textContent : '';

  if (btn) {
    btn.textContent = 'adding...';
    btn.disabled = true;
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });
    const data = await res.json();

    if (data.id) {
      if (btn) btn.textContent = 'added ✓';
      QTR.updateCartCount();
      setTimeout(function () {
        if (btn) {
          btn.textContent = orig;
          btn.disabled = false;
        }
      }, 2000);
    }
  } catch (err) {
    if (btn) {
      btn.textContent = orig;
      btn.disabled = false;
    }
  }
};

QTR.updateCartCount = async function () {
  try {
    const res  = await fetch('/cart.js');
    const cart = await res.json();
    const el   = document.querySelector('.cart-count');
    if (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
    }
  } catch (_) {}
};

// ─── CAROUSEL ───────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    const track  = carousel.querySelector('.carousel__track');
    const slides = carousel.querySelectorAll('.carousel__slide');
    const dots   = carousel.querySelectorAll('.carousel__dot');
    const btnPrev = carousel.querySelector('.carousel__btn--prev');
    const btnNext = carousel.querySelector('.carousel__btn--next');
    const current = carousel.querySelector('.carousel__current');

    if (!track || slides.length === 0) return;

    let idx = 0;
    const total = slides.length;

    function goTo(n) {
      idx = (n + total) % total;
      track.style.transform = 'translateX(-' + (idx * 100) + '%)';

      dots.forEach(function (d, i) {
        d.classList.toggle('carousel__dot--active', i === idx);
      });

      if (current) current.textContent = idx + 1;

      if (btnPrev) btnPrev.disabled = false;
      if (btnNext) btnNext.disabled = false;
    }

    if (btnPrev) btnPrev.addEventListener('click', function () { goTo(idx - 1); });
    if (btnNext) btnNext.addEventListener('click', function () { goTo(idx + 1); });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i); });
    });

    // Swipe support
    let startX = 0;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? idx + 1 : idx - 1);
    }, { passive: true });

    // Keyboard when carousel is focused
    carousel.setAttribute('tabindex', '0');
    carousel.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(idx - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(idx + 1); }
    });

    goTo(0);
  });
});
